const it_IT = {
    "title-bold": "Calcolatore",
    "title-light": "di tolleranza",
    "subtitle-bold": "tipi di",
    "subtitle-light": "tolleranze ISO",
    "holes": "fori",
    "shafts": "assi",
    "nominal-size": "dimensione nominale",
    "letter": "lettera",
    "number": "numero",
    "calculate": "calcolare",
    "diameter-must-be-more-than-zero": "Il diametro deve essere maggiore di 0",
    "letter-number-combination-not-found": "Combinazione lettera-numero non trovata",
    "results": "risultati",
    "inferior-measure": "inferiore",
    "inferior-measure-expanded": "misura inferiore",
    "superior-measure": "superiore",
    "superior-measure-expanded": "misura superiore",
    "average": "media",
    "tolerance-range": "intervallo",
    "tolerance-range-expanded": "intervallo di tolleranza",
    "not-exist": "Non esistono valori"
}


export default it_IT;